//-------card product variant code starts----------//
document.addEventListener("DOMContentLoaded", function () {
  // Get variant id using custom js
  const cstmVariants = document.querySelectorAll(
    ".cstm-product-card-wrapper .main_value"
  );
  cstmVariants.forEach((cstmVariant) => {
    cstmVariant.addEventListener("click", function (event) {
      var button = event.target.closest(".cstm_variant_wrapper .main_value");
      var variantId = button.getAttribute("data-variant-id");
      var variantPrice = button.getAttribute("data-price");
      var variantImage = button.getAttribute("data-variant-image");
      // Get the closest card wrapper
      var cardWrapper = button.closest(".card-wrapper");
      if (cardWrapper) {
        var mediaImage = cardWrapper.querySelector(".card__media img");
        if (mediaImage && variantImage) {
          mediaImage.removeAttribute("srcset");
          mediaImage.removeAttribute("sizes");
          mediaImage.setAttribute("src", variantImage);
        }
      }
      // Update the price
      var parentGridItem = button.closest(".grid__item");
      var finalPriceTarget = parentGridItem.querySelector(".price-item");
      if (finalPriceTarget) {
        finalPriceTarget.innerText = "From ₹ " + variantPrice;
      } else {
        console.log("finalPriceTarget not found");
      }
      // Update the hidden input with the variant ID
      var container = button.closest(".card__content");
      var productVariantIdInput = container.querySelector(
        ".product-variant-id"
      );
      if (productVariantIdInput) {
        productVariantIdInput.value = variantId;
      } else {
        console.log("productVariantIdInput not found");
      }
    });
  });
});
// document.addEventListener("DOMContentLoaded", function() {
//   var variantDivs = document.querySelectorAll(".cstm_variant_wrapper .main_value");
//   var active_btn = document.querySelector(".active_btn");
//   variantDivs.forEach((div) => div.addEventListener("click", function() {
//     variantDivs.forEach((d) => d.classList.remove("active_btn"));
//     this.classList.add("active_btn");
//   }));
// });
document.addEventListener("DOMContentLoaded", function () {
  var variantWrappers = document.querySelectorAll(".cstm_variant_wrapper");
  variantWrappers.forEach((wrapper) => {
    var variantDivs = wrapper.querySelectorAll(".main_value");
    variantDivs.forEach((div) =>
      div.addEventListener("click", function () {
        variantDivs.forEach((d) => d.classList.remove("active_btn"));
        this.classList.add("active_btn");
      })
    );
  });
});
//-------card product variant code ends----------//

// All external URL links on Shopify should open up a new tab
var links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
  if (links[i].protocol === "tel:" || links[i].protocol === "mailto:") {
    links[i].target = "";
    links[i].rel = "";
  } else {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = "_blank";
      links[i].rel = "noreferrer noopener";
    }
  }
}

$(document).ready(function () {
  //--------cstm mega menu accordian code starts---------//
  var menuItem = $(
    ".cstm_header_wrapper .mega-menu .cstm_childlink .cstm-has-list-unstyled"
  );
  $(".cstm-list-unstyled").hide(); // Hide all dropdowns initially
  // Show the first dropdown by default
  $(
    ".cstm_header_wrapper .mega-menu .cstm_childlink:first-child .cstm-list-unstyled"
  ).show();
  $(".cstm_header_wrapper .mega-menu .cstm_childlink:first-child").addClass(
    "arrow-animate"
  );
  $(menuItem).click(function () {
    console.log("menuItem>>>", menuItem);
    $(menuItem)
      .not(this)
      .parents(".cstm_header_wrapper .mega-menu .cstm_childlink")
      .find(".cstm-list-unstyled")
      .slideUp();
    $(menuItem)
      .not(this)
      .parents(".cstm_header_wrapper .mega-menu .cstm_childlink")
      .removeClass("arrow-animate");
    $(this)
      .parents(".cstm_header_wrapper .mega-menu .cstm_childlink")
      .find(".cstm-list-unstyled")
      .slideToggle();
    $(this)
      .parents(".cstm_header_wrapper .mega-menu .cstm_childlink")
      .toggleClass("arrow-animate");
  });
  //--------cstm mega menu accordian code ends---------//

  //--------footer menu mobile accordian code starts---------//
  if ($(window).width() < 750) {
    var menuHeading = $(
      ".cstm_footer_design .footer__blocks-wrapper .cstm_footer_block_heading_wrapper"
    );
    $(".cstm_footer_list_unstyled").hide(); // Hide all dropdowns initially
    // Show the first dropdown by default
    $(
      ".cstm_footer_design .footer__blocks-wrapper .cstm_footer_block_menu:first-child .cstm_footer_list_unstyled"
    ).show();
    $(
      ".cstm_footer_design .footer__blocks-wrapper .cstm_footer_block_menu:first-child"
    ).addClass("icon-animate");
    $(menuHeading).click(function () {
      $(menuHeading)
        .not(this)
        .parents(
          ".cstm_footer_design .footer__blocks-wrapper .cstm_footer_block_menu"
        )
        .find(".cstm_footer_list_unstyled")
        .slideUp();
      $(menuHeading)
        .not(this)
        .parents(
          ".cstm_footer_design .footer__blocks-wrapper .cstm_footer_block_menu"
        )
        .removeClass("icon-animate");
      $(this)
        .parents(
          ".cstm_footer_design .footer__blocks-wrapper .cstm_footer_block_menu"
        )
        .find(".cstm_footer_list_unstyled")
        .slideToggle();
      $(this)
        .parents(
          ".cstm_footer_design .footer__blocks-wrapper .cstm_footer_block_menu"
        )
        .toggleClass("icon-animate");
    });
  }
  //--------footer menu mobile accordian code ends---------//

  //--------faq filter code code starts---------//
  $(".faq_question").click(function () {
    $(this).parent().toggleClass("active").siblings().removeClass("active");
  });
  $(".faq_head").click(function () {
    var currentTab = $(this).attr("current_tab");
    $(this).addClass("activeTab").siblings().removeClass("activeTab");
    $(".faq_contents").hide();
    $(".View_all_content").show();
    $(".less_all_content").hide();
    $(".faq_contents").each(function () {
      var activefaq = $(this).attr("collection_title");
      if (currentTab == activefaq) {
        $(this)
          .addClass("activeTab_FAQ")
          .siblings()
          .removeClass("activeTab_FAQ");
        $(".faq_contents.activeTab_FAQ").show();
      }
    });
  });
  $(".View_all_content").click(function () {
    $(this).hide();
    $(".less_all_content").show();
    if ($(".faq_head.faq_all").hasClass("activeTab")) {
      $(".faq_contents").show();
      $(".activeTab_FAQ").find(".togglecontent").removeClass("hide_faq");
      $(".faq_qus_ans").removeClass("active");
    } else {
      $(".activeTab_FAQ").find(".togglecontent").removeClass("hide_faq");
    }
    // $('.activeTab.faq_all').find('.faq_contents').show();
  });
  $(".less_all_content").click(function () {
    $(this).hide();
    $(".View_all_content").show();
    if ($(".faq_head.faq_all").hasClass("activeTab")) {
      $(".faq_contents").hide();
      $(".activeTab_FAQ").show();
      $(".activeTab_FAQ").find(".togglecontent").addClass("hide_faq");
    } else {
      $(".activeTab_FAQ").find(".togglecontent").addClass("hide_faq");
    }
  });
  $(".faq_all").click(function () {
    $(".faq_contents.activeTab_FAQ").show();
  });
  //--------faq filter code ends---------//

  //---------pcp-collection-page-section-slider code starts---------//
  var imageBlock = $(".pcp-col-image-text img").attr("image-block");
  if (imageBlock > 1) {
    $(".pcp-col-right--div").slick({
      slidesToScroll: 1,
      slidesToShow: 1,
      dots: true,
      arrows: true,
      prevArrow:
        '<button type="button" class="slick-prev"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 18L9 12L15 6" stroke="white" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      nextArrow:
        '<button type="button" class="slick-next"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 18L15 12L9 6" stroke="white" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    });
  }
  //--------pcp-collection-page-section-slider code ends---------//

  //--------testimonial-customer-review-slider code starts---------//
  $(".main_container_text").each(function (index) {
    if (index % 2 === 0) {
      $(this)
        .next()
        .addBack()
        .wrapAll('<div class="group_container_text"></div>');
    }
  });
  var forLoop = $(".sliders_text_containers .main_container_text").attr(
    "forloop"
  );
  if (forLoop <= 2) {
    $(".sliders_text_containers").addClass("sliders_text_containers_display");
  }
  if (forLoop > 2) {
    $(".sliders_text_containers").slick({
      dots: true,
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow:
        '<button type="button" class="arrow_left_arrow"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 18L9 12L15 6" stroke="white" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      nextArrow:
        '<button type="button" class="arrow_right_arrow"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 18L15 12L9 6" stroke="white" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      responsive: [
        {
          breakpoint: 749,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
          },
        },
      ],
    });
  }
  //--------testimonial-customer-review-slider code ends---------//

  //--------featured blog slider code starts---------//
  // $('.cstm_featured_blog .cstm_show_blog_slider').slick({
  //   dots: true,
  //   infinite: true,
  //   slidesToShow: 3,
  //   slidesToScroll: 1,
  //   responsive: [
  //     {
  //       breakpoint: 990,
  //       settings: {
  //         slidesToShow: 2,
  //         slidesToScroll: 1,
  //         infinite: true,
  //         dots: true
  //       }
  //     },
  //     {
  //       breakpoint: 749,
  //       settings: {
  //         slidesToShow: 1,
  //         slidesToScroll: 1,
  //         infinite: true,
  //         dots: true
  //       }
  //     }
  //   ]
  // });
  //--------featured blog slider code ends---------//
});

//-------special characters remove from search input code starts--------//
document.addEventListener("DOMContentLoaded", function () {
  const searchForm = document.querySelector('form[action="/search"]');
  const searchInput = searchForm.querySelector(".cstm_search_input");
  const searchInputError = searchForm.querySelector(".cstm_search_input_error");

  // Define your regex pattern here
  const regexPattern = /^[a-zA-Z0-9\s]*$/;

  searchForm.addEventListener("submit", function (event) {
    const inputValue = searchInput.value.trim();

    // Check if the input matches the regex pattern
    if (!regexPattern.test(inputValue)) {
      event.preventDefault(); // Prevent the form from submitting
      searchInputError.textContent =
        "Special characters are not allowed in search.";
    }
  });
});
//-------special characters remove from search input code ends--------//
